class a {
  /** @type {T} */
  #e;
  /** @type {Promise<DefferedResult<T>>} */
  #r;
  /**
   * @param {T} promise
   */
  constructor(e) {
    this.#e = e, this.#r = Promise.resolve(this.#e).then((r) => (
      /** @type {const} */
      { ok: !0, value: r, error: null }
    )).catch((r) => (
      /** @type {const} */
      { ok: !1, error: r, value: null }
    ));
  }
  get value() {
    return this.#t();
  }
  async #t() {
    let e = await this.#r;
    if (!e.ok) throw e.error;
    return e.value;
  }
}
function n(o, e) {
  return new Promise((s, t) => {
    if (e.aborted) return t(e.reason);
    e.addEventListener("abort", () => t(e.reason)), o().then(s).catch(t);
  });
}
export {
  a as DefferedPromise,
  n as makeAbortablePromise
};
